'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';

const COOKIE_CONSENT_KEY = 'cookie-consent-preferences';

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [preferences, setPreferences] = useState({
    accepted: false,
  });

  useEffect(() => {
    // Check if the user has already set preferences
    const storedPreferences = localStorage.getItem(COOKIE_CONSENT_KEY);

    if (!storedPreferences) {
      // If no preferences are stored, show the banner
      setIsVisible(true);
    } else {
      // Load stored preferences
      try {
        setPreferences(JSON.parse(storedPreferences));
      } catch (error) {
        console.error('Error parsing cookie consent preferences:', error);
        // If there's an error parsing, show the banner again
        setIsVisible(true);
      }
    }

    // Listen for storage events to detect when localStorage is cleared
    const handleStorageChange = (e) => {
      if (e.key === COOKIE_CONSENT_KEY && e.newValue === null) {
        // Cookie preferences were cleared, show banner again
        setIsVisible(true);
        setPreferences({ accepted: false });
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const savePreferences = (newPreferences) => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(newPreferences));
    setPreferences(newPreferences);
    setIsVisible(false);

    // Dispatch custom event to notify other components that preferences have changed
    window.dispatchEvent(new Event('cookieConsentUpdated'));
  };

  const handleAcceptAll = () => {
    const allAccepted = {
      accepted: true,
    };
    savePreferences(allAccepted);
  };

  const handleRejectAll = () => {
    const allRejected = {
      accepted: false,
    };
    savePreferences(allRejected);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed left-4 bottom-4 z-50 bg-white shadow-lg p-4 border border-gray-200 rounded-lg max-w-sm">
      <div className="">
        <div className="flex flex-col items-start gap-4">
          <div>
            <h3 className="text-lg font-semibold mb-2">Cookie Consent</h3>
            <p className="text-sm text-gray-600 mb-4">
              We use cookies to improve your experience. Strictly necessary cookies are always active.
              <Link href="/cookie-policy" className="text-blue-600 hover:underline ml-1">
                Learn more
              </Link>
            </p>
          </div>
          <div className="flex flex-col w-full gap-2">
            <button
              onClick={handleAcceptAll}
              className="w-full bg-[#212c55] hover:bg-blue-600 text-white py-2 px-4 rounded text-center"
            >
              Accept All
            </button>
            <button
              onClick={handleRejectAll}
              className="w-full bg-gray-200 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded text-center"
            >
              Reject All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
